import { Button, Icon, Popover, Tooltip } from 'antd';
import cn from 'classnames';
import React from 'react';

import Btn from '../../../../../../../../components/btn';
import { CreateServiceSetPreview } from './ServiceSetsPreview';
import styles from './ServiceSetsSection.module.scss';

export const ServiceSetEditorActions = ({
  isSaving,
  previewServices,
  serviceSetName,
  serviceSetComment,
  submitButtonDisabled,
  submitButtonTooltip,
  onCancel,
  onSubmit,
}) => (
  <div className={styles.serviceSetActions}>
    <Btn
      htmlType="button"
      disabled={isSaving}
      icon="close"
      className={cn(styles.addButton, {
        [styles.addButtonDisabled]: isSaving,
      })}
      onClick={onCancel}
    >
      Отмена
    </Btn>
    <Popover
      trigger="hover"
      placement="leftTop"
      content={
        <CreateServiceSetPreview
          serviceSetName={serviceSetName}
          serviceSetComment={serviceSetComment}
          previewServices={previewServices}
        />
      }
    >
      <Button
        htmlType="button"
        className={styles.serviceSetPreviewButton}
        aria-label="Предпросмотр набора услуг"
      >
        <Icon type="eye" />
      </Button>
    </Popover>
    <Tooltip title={submitButtonTooltip}>
      <span className={styles.disabledButtonWrapper}>
        <Btn
          htmlType="button"
          disabled={submitButtonDisabled}
          loading={isSaving}
          icon="save"
          className={cn(styles.addButton, {
            [styles.addButtonDisabled]: submitButtonDisabled,
          })}
          onClick={onSubmit}
        >
          Сохранить
        </Btn>
      </span>
    </Tooltip>
  </div>
);
